// extracted by mini-css-extract-plugin
export default {"container":"Tua-z","tab":"Uua-z","selected":"Vua-z"};